<template>
    <div>
        <v-system-bar app>
            <v-spacer></v-spacer>

            <v-icon>mdi-square</v-icon>

            <v-icon>mdi-circle</v-icon>

            <v-icon>mdi-triangle</v-icon>
        </v-system-bar>

        <v-app-bar
                app
                clipped-right
                flat
                height="72"
        >
            <v-spacer></v-spacer>

            <v-responsive max-width="156">
                <v-text-field
                        dense
                        flat
                        hide-details
                        rounded
                        solo-inverted
                ></v-text-field>
            </v-responsive>
        </v-app-bar>

        <v-navigation-drawer
                v-model="drawer"
                app
        >

            <v-sheet
                    color="grey darken-4"
                    dark
                    width="100%"
            >
                <v-list-item two-line>
                    <v-list-item-avatar size="60" rounded>
                        <img src="@/assets/logo_short_white.png">
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>CTRUST.club</v-list-item-title>
                        <v-list-item-subtitle>Кабинет инвестора</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-sheet>

            <v-list
                    dense
                    rounded
            >
                <v-list-item
                        v-for="item in items"
                        :key="item.title"
                        link
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-navigation-drawer
                app
                clipped
                right
        >
            <template v-slot:prepend>
                <v-list-item two-line>
                    <v-list-item-avatar>
                        <img src="https://randomuser.me/api/portraits/women/81.jpg">
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>Помятихина Оксана</v-list-item-title>
                        <v-list-item-subtitle>Инвестор</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </template>

            <v-divider></v-divider>

            <v-subheader>
                Основные показатели
            </v-subheader>
            <!-- indicators -->
        </v-navigation-drawer>

        <v-main>
            <router-view></router-view>
        </v-main>
    </div>
</template>
<script>
  import {mapGetters, mapState} from 'vuex'
  // import ManagerDrawerItems from '@/components/manager/DrawerItems.vue'
  // import ClientDrawerItems from '@/components/client/DrawerItems.vue'
  import {LOGOUT} from '@/store/types'

  export default {
    name: 'App',
    // components: {
    //   'client_drawer_items': ClientDrawerItems,
    //   'manager_drawer_items': ManagerDrawerItems
    // },
    computed: {
      ...mapGetters([
        'isAuthenticated'
      ]),
      ...mapState([
        'auth'
      ]),
      username () {
        return this.auth.user.username
      },
      userGroups () {
        return this.auth.user.groups
      },
      isAdmin () {
        return this.userGroups.findIndex(function (element) {
          return element.name === 'manager'
        }) >= 0
      }
    },
    data: () => ({
        items: [
          {
              title:'Портфель',
              icon: 'mdi-briefcase-variant'
          },
          {
              title:'История операций',
              icon: 'mdi-history'
          }
        ],
        drawer: true,
        clipped: true,
        fixed: false,
        drawerWidth: 300,
        right: true,
        rightDrawer: false,
        title: 'HTSF Personal Account'
    }),
    methods: {
      login () {
        console.log('Logged In')
      },
      logout () {
        this.$store.dispatch(LOGOUT)
      }
    },
    mounted () {
      this.$store.dispatch('inspectToken')
    },
    updated () {
      this.$store.dispatch('inspectToken')
    }
  }
</script>
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  /deep/ .v-toolbar--clipped{
    z-index: 15;
  }



</style>
